export default "__VITE_ASSET__B85qXJZU__"